import { ReactNode } from 'react';
import { useRouteAccess } from '../../../accessControl/useRouteAccess';
import LockedContent from '../LockedContent';

interface ILockedRouteContent {
  /** href de destino do conteúdo (ex.: '/cursos/regulares'). */
  href: string;
  children: ReactNode;
  className?: string;
  /** Texto exibido sobre o conteúdo borrado. */
  label?: string;
  /** Versão reduzida do overlay, para cards baixos/estreitos. */
  compact?: boolean;
}

/**
 * Envolve um conteúdo que leva a uma rota. Se o usuário não tiver acesso
 * (via platformModules), borra o conteúdo, desabilita a interação e mostra
 * um upsell que redireciona direto para a página de vendas. Com acesso,
 * renderiza o conteúdo normalmente.
 */
export default function LockedRouteContent({
  href,
  children,
  className,
  label = 'Quer ir além?',
  compact = false,
}: ILockedRouteContent) {
  const { canAccess } = useRouteAccess();

  return (
    <LockedContent
      locked={!canAccess(href)}
      className={className}
      label={label}
      compact={compact}
    >
      {children}
    </LockedContent>
  );
}
